/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './revokeVerifications.defs.js'
export { main as default } from './revokeVerifications.defs.js'
